// extracted by mini-css-extract-plugin
export default {"button":"Button_button__iEiBG","selected":"Button_selected__YhPgW"};